module.exports = __webpack_public_path__ + "img/6.4892c756.png";